import { Environments, getEnvironmentName } from "./environment-finder";
import { FlagValues, SettingsConfig } from "./settings-type";

type EnvFlagMap = Record<Environments, Partial<SettingsConfig>>;

let flagMap: EnvFlagMap, defaultFlags: SettingsConfig;

export function importSettings(
  defaultFlagParam: SettingsConfig,
  envFlagMap: EnvFlagMap,
) {
  defaultFlags = defaultFlagParam;
  flagMap = envFlagMap;
}

export function flagIsEnabled(flagName: FlagValues): boolean {
  const envName = getEnvironmentName();
  const currentEnvironmentFlags = flagMap[envName] || {};
  const currentEnvFlagValue = currentEnvironmentFlags[flagName];

  return currentEnvFlagValue !== undefined
    ? currentEnvFlagValue
    : defaultFlags[flagName];
}
